export default __webpack_public_path__ + "static/media/road-map.2468a739.png";